import type {AnyAction} from 'redux'
import {readDescriptionClicked} from '../../actions/schedule'
import type {State} from '../../reducers'

export const handleScheduleItemDescriptionView = (state: State, action: AnyAction) => {
  if (readDescriptionClicked.match(action)) {
    return {
      evid: 194,
      event_id: state.event.id,
      schedule_item_id: action.payload.itemId,
    }
  }
}
